import React from "react";

import { Switch } from "antd";
import "./TestViewToggle.css";

export default function TestViewToggle({ handleTestToggle, enableTests }) {
  return (
    <Switch
      className="TemplateBuilder__TestViewToggle"
      checkedChildren=""
      unCheckedChildren=""
      defaultChecked={enableTests}
      onClick={() => handleTestToggle(!enableTests)}
    />
  );
}
